const FontSizeValues = Object.freeze({
    s8: 8,
    s10: 10,
    s12: 12,
    s14: 14,
    s16: 16,
    s20: 20,
    s24: 24,
    s30: 30,
    s36: 36,
    s42: 42,
    s60: 60,
});
const LineHeightValues = Object.freeze({
    l10: 10,
    l14: 14,
    l16: 16,
    l20: 20,
    l24: 24,
    l28: 28,
    l32: 32,
    l36: 36,
    l48: 48,
    l50: 50,
    l72: 72,
});
const TypographyValues = Object.freeze({
    t1: {
        fontSize: FontSizeValues.s8,
        lineHeight: LineHeightValues.l10,
    },
    t2: {
        fontSize: FontSizeValues.s10,
        lineHeight: LineHeightValues.l14,
    },
    t3: {
        fontSize: FontSizeValues.s12,
        lineHeight: LineHeightValues.l16,
    },
    t4: {
        fontSize: FontSizeValues.s14,
        lineHeight: LineHeightValues.l20,
    },
    t5: {
        fontSize: FontSizeValues.s16,
        lineHeight: LineHeightValues.l24,
    },
    t6: {
        fontSize: FontSizeValues.s20,
        lineHeight: LineHeightValues.l28,
    },
    t7: {
        fontSize: FontSizeValues.s24,
        lineHeight: LineHeightValues.l32,
    },
    t8: {
        fontSize: FontSizeValues.s30,
        lineHeight: LineHeightValues.l36,
    },
    t9: {
        fontSize: FontSizeValues.s36,
        lineHeight: LineHeightValues.l48,
    },
    t10: {
        fontSize: FontSizeValues.s42,
        lineHeight: LineHeightValues.l50,
    },
    t11: {
        fontSize: FontSizeValues.s60,
        lineHeight: LineHeightValues.l72,
    },
});

export { FontSizeValues, LineHeightValues, TypographyValues };
